import {
  AUTHORIZATION,
  LOGIN_WITH_EMAIL,
  LOGIN_WITH_GOOGLE_AUTH2,
  LOGIN_WITH_ECPF,
  LOGOUT,
} from './types';

export const authorize = () => ({ type: AUTHORIZATION.AUTHORIZE });
export const unauthorize = () => ({ type: AUTHORIZATION.UNAUTHORIZE });

export const setToken = (token) => ({ type: AUTHORIZATION.SET_TOKEN, payload: { token } });

export const setTokenManual = (token) => ({
  type: AUTHORIZATION.SET_TOKEN_MANUAL,
  payload: { token },
});

export const removeToken = () => ({ type: AUTHORIZATION.REMOVE_TOKEN });

export const loginWithEmailSubmit = (payload) => ({ type: LOGIN_WITH_EMAIL.SUBMIT, payload });
export const loginWithEmailSuccess = (response) => ({
  type: LOGIN_WITH_EMAIL.SUCCESS,
  payload: response,
});

export const loginWithEmailFailure = (error) => ({
  type: LOGIN_WITH_EMAIL.FAILURE,
  payload: error,
});

export const showCaptcha = () => ({
  type: LOGIN_WITH_EMAIL.TOGGLE_CAPTCHA,
  payload: { show: true },
});

export const hideCaptcha = () => ({
  type: LOGIN_WITH_EMAIL.TOGGLE_CAPTCHA,
  payload: { show: false },
});

export const loginWithGoogleAuth2Request = () => ({ type: LOGIN_WITH_GOOGLE_AUTH2.REQUEST });
export const loginWithGoogleAuth2Success = () => ({ type: LOGIN_WITH_GOOGLE_AUTH2.SUCCESS });

export const loginWithGoogleAuth2Failure = (error) => ({
  type: LOGIN_WITH_GOOGLE_AUTH2.FAILURE,
  payload: error,
});

export const loginWithECPFSubmit = () => ({ type: LOGIN_WITH_ECPF.SUBMIT });
export const loginWithECPFSuccess = () => ({ type: LOGIN_WITH_ECPF.SUCCESS });
export const loginWithECPFFailure = (error) => ({ type: LOGIN_WITH_ECPF.FAILURE, payload: error });

export const logoutManual = () => ({ type: LOGOUT.MANUAL });
export const logoutAutomatic = () => ({ type: LOGOUT.AUTOMATIC });
